import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { readCallback } from '../services/googleRedirect';
import { finishRedirectConnect } from '../services/googleSync';

// Google sends phones back here after the Google Calendar connect redirect (see services/googleRedirect.js).
export default function GoogleCallback() {
  const location = useLocation(); const navigate = useNavigate();
  const [msg, setMsg] = useState('Finishing Google Calendar connection…');
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return; ran.current = true;
    (async () => {
      const cb = readCallback(location.search);
      let text = cb.message || '';
      if (cb.ok) {
        const r = await finishRedirectConnect(cb.code, cb.redirectUri);
        text = r.ok ? `Connected as ${r.email || 'your Google account'}. Your upcoming Resi appointments are being added to Google Calendar.` : `Could not connect: ${r.message}`;
      } else text = `Could not connect: ${text}`;
      try { window.sessionStorage.setItem('resi.googleOAuthResult', text); } catch (e) { /* ignore */ }
      setMsg(text);
      navigate(cb.returnTo || '/profile', { replace: true });
    })();
  }, [location.search, navigate]);
  return <div style={{ padding: 24, fontSize: 16 }}>{msg}</div>;
}
